module.exports = __webpack_public_path__ + "static/steps-img1-2fe4973b01a72f19e85b1e6a9947630e.png";